import { Carousel as AntdCarousel } from 'antd';
import styled, { css } from 'styled-components';

/**
 * The photo carousel of tools: primary-colour arrows and dots, slides centred.
 * `$fillViewport`: on wide screens (≥ 1600 px) it takes the viewport's height (meter detail page);
 * without it the slides keep their own height (model galleries).
 */
export const StyledCarousel = styled(AntdCarousel)<{ $fillViewport?: boolean }>`
  text-align: center;
  margin-bottom: 30px;

  &&& {
    .slick-slider,
    .slick-list {
      height: auto;
    }

    .slick-track {
      height: auto;
      display: flex;
    }

    .slick-slide {
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;

      > div {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .slick-prev,
    .slick-next {
      z-index: 2;
      width: 40px;
      height: 40px;

      &:before {
        font-size: 40px;
        color: ${({ theme }) => theme.color.theme.primary};
      }
    }

    .slick-prev {
      left: 10px;
    }

    .slick-next {
      right: 10px;
    }

    > .slick-dots {
      bottom: -20px;
      height: 20px;
      align-items: center;

      li button {
        background: ${({ theme }) => theme.color.theme.primary};
        opacity: unset;
      }

      li.slick-active button {
        background: ${({ theme }) => theme.color.theme.primary};
        z-index: 1;
      }
    }

    ${({ $fillViewport }) =>
      $fillViewport &&
      css`
        @media (min-width: 1600px) {
          height: calc(100vh - 340px);
          .slick-slider,
          .slick-list {
            height: 100%;
          }
          .slick-track {
            height: 100%;
            display: flex;
          }

          .slick-slide {
            height: 100%;
          }
        }
      `}
  }
`;
